import { ReactNode } from 'react'
import { createPortal } from 'react-dom'

const Portal = ({ children }: { children: ReactNode }) => {
    let mount = document.getElementById('combobox-parent')
    if (!mount) {
        mount = document.createElement('div')
        mount.id = 'combobox-parent'
        document.body.appendChild(mount)
    }

    return createPortal(children, mount)
}

export default Portal
